import ExcelJS from 'exceljs';

export class WorkbookDownloadError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'WorkbookDownloadError';
	}
}

export const downloadWorkbook = async (workbook: ExcelJS.Workbook, fileName: string): Promise<void> => {
	if (typeof window === 'undefined' || typeof document === 'undefined') {
		throw new WorkbookDownloadError('Browser download is unavailable in this environment.');
	}

	const data = await workbook.xlsx.writeBuffer();
	const blob = new Blob([data], {
		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	});

	const url = window.URL.createObjectURL(blob);
	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = fileName;
	document.body.appendChild(anchor);
	anchor.click();
	document.body.removeChild(anchor);
	window.URL.revokeObjectURL(url);
};
